module.exports = __webpack_public_path__ + "img/sale.f1727eab.png";